import React from "react";
import { isLoading, Loading } from "../Loading";
import { ClockedInStatus } from "../messages";
import { AppState } from "../system/AppState";

const useClockedInStatus = (appState: AppState) => {
  const [clockedInStatus, setClockedInStatus] = React.useState<ClockedInStatus | Loading>(
    appState.clockedInStatus
  );

  React.useEffect(() => {
    const event = appState.onClockedInStatusUpdated.register(() => {
      if (!isLoading(appState.clockedInStatus)) {
        setClockedInStatus(appState.clockedInStatus);
      }
    });

    return () => event.unregister();
  }, [appState.clockedInStatus, appState.onClockedInStatusUpdated]);

  return clockedInStatus;
};

export default useClockedInStatus;
